import React from "react";
import { Link } from "react-router-dom";
import { NavDropdown, Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./Shopping.css";
import { useState, useEffect } from "react";

function ShoppingCart() {
  const cartItems = useSelector((state) => state.shoppingCart);
  const [subTotal, setSubTotal] = useState(0);
  const [selected, setSelected] = useState("");
  const [showDropDown, setShowDropDown] = useState(false);

  useEffect(() => {
    setSubTotal(0);
    cartItems.forEach((element) => {
      setSubTotal((prev) => prev + element.price * element.quantity);
    });
  }, [cartItems]);

  return (
    <div>
      <Nav>
        <NavDropdown
          show={showDropDown}
          id="nav-dropdown-light-example"
          title={
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="isEnable"
              onClick={() => setShowDropDown((prev) => !prev)}
            >
              <path d="M23.76 4.248c-0.096-0.096-0.24-0.24-0.504-0.24h-18.48l-0.48-2.4c-0.024-0.288-0.384-0.528-0.624-0.528h-2.952c-0.384 0-0.624 0.264-0.624 0.624s0.264 0.648 0.624 0.648h2.424l2.328 11.832c0.312 1.608 1.848 2.856 3.48 2.856h11.28c0.384 0 0.624-0.264 0.624-0.624s-0.264-0.624-0.624-0.624h-11.16c-0.696 0-1.344-0.312-1.704-0.816l14.064-1.92c0.264 0 0.528-0.24 0.528-0.528l1.968-7.824v-0.024c-0.024-0.048-0.024-0.288-0.168-0.432zM22.392 5.184l-1.608 6.696-14.064 1.824-1.704-8.52h17.376zM8.568 17.736c-1.464 0-2.592 1.128-2.592 2.592s1.128 2.592 2.592 2.592c1.464 0 2.592-1.128 2.592-2.592s-1.128-2.592-2.592-2.592zM9.888 20.328c0 0.696-0.624 1.32-1.32 1.32s-1.32-0.624-1.32-1.32 0.624-1.32 1.32-1.32 1.32 0.624 1.32 1.32zM18.36 17.736c-1.464 0-2.592 1.128-2.592 2.592s1.128 2.592 2.592 2.592c1.464 0 2.592-1.128 2.592-2.592s-1.128-2.592-2.592-2.592zM19.704 20.328c0 0.696-0.624 1.32-1.32 1.32s-1.344-0.6-1.344-1.32 0.624-1.32 1.32-1.32 1.344 0.624 1.344 1.32z"></path>
            </svg>
          }
          menuVariant=""
        >
          <NavDropdown.Item>
            <div
              className="d-flex justify-content-start align-items-center  p-1"
              style={{ fontFamily: "'Lobster Two', cursive", fontSize: "1.5rem" }}
            >
              <img
                src="https://www.svgrepo.com/show/219056/grape.svg"
                intrinsicsize="512 x 512"
                width="20"
                height="20"
                srcSet="https://www.svgrepo.com/show/219056/grape.svg 4x"
                alt="Grape SVG Vector"
                title="Grape SVG Vector"
              />
              <span className="">Carrito de compras</span>
            </div>
          </NavDropdown.Item>
          <NavDropdown.Divider />
          <div className="navdropdown.item">
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th colSpan="2" scope="col first-col">
                    Items
                  </th>
                  <th scope="col">#</th>
                  <th scope="col">$</th>
                  <th scope="col">Subtotal</th>
                </tr>
              </thead>
              <tbody className="">
                {cartItems.map((item) => (
                  <tr className="navlink" key={item._id}>
                    <td>
                      <img
                        className="img-fluid shadow rounded mini"
                        src={`${item.picture}`}
                        alt={item.name}
                      />
                    </td>
                    <td className="first-name">
                      <div>
                        <Link onClick={() => setShowDropDown(false)} to={`/producto/${item.slug}`}>
                          {item.name}
                        </Link>
                      </div>
                    </td>
                    <td>{item.quantity}</td>
                    <td>${item.price}</td>
                    <td>{item.price * item.quantity}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="2" className="last-name">
                    Subtotal:
                  </td>
                  <td colSpan="2"></td>
                  <td className="text-align-center">$ {subTotal}</td>
                </tr>
                <tr>
                  <td colSpan="5">
                    <Link
                      to="/productos"
                      className="btn btn-outline-secondary ms-4"
                      onClick={() => setShowDropDown(false)}
                    >
                      Continuar comprando
                    </Link>

                    <Link
                      to="/ver-pedido"
                      className="btn btn-wine ms-2"
                      onClick={() => setShowDropDown(false)}
                    >
                      Finalizar compra
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </NavDropdown>
      </Nav>
    </div>
  );
}

export default ShoppingCart;
